import { Box, useTheme } from "@mui/material";
import { Typography } from "@mui/material";

export const FreePalestine = () => {
    const theme = useTheme();
	return (
		<Box sx={{
            borderTopWidth: 1,
            borderTopStyle: "solid",
            borderTopColor: "divider",
            paddingX: 2.5,
            paddingY: 2,
            backgroundColor: theme.palette.background.paper,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1
        }}>
            <Box
                sx={{
                    width: 24,
                    height: 16,
                    position: 'relative',
                    borderRadius: 0.5,
                    overflow: 'hidden',
                    border: '1px solid',
                    borderColor: theme.palette.divider
                }}
            >
                {/* Palestinian Flag */}
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '33.33%',
                        backgroundColor: '#000000' // Black stripe
                    }}
                />
                <Box
                    sx={{
                        position: 'absolute',
                        top: '33.33%',
                        left: 0,
                        width: '100%',
                        height: '33.33%',
                        backgroundColor: '#FFFFFF' // White stripe
                    }}
                />
                <Box
                    sx={{
                        position: 'absolute',
                        top: '66.66%',
                        left: 0,
                        width: '100%',
                        height: '33.34%',
                        backgroundColor: '#007A3D' // Green stripe
                    }}
                />
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: 0,
                        height: 0,
                        borderTop: '8px solid transparent',
                        borderBottom: '8px solid transparent',
                        borderLeft: '12px solid #CE1126' // Red triangle
                    }}
                />
            </Box>
            <Typography
                variant="body2"
                sx={{
                    color: theme.palette.text.primary,
                    fontWeight: 600,
                    fontSize: 14,
                    letterSpacing: 0.5,
                }}
            >
                Free Palestine
            </Typography>
        </Box>
	);
};